export default "__VITE_ASSET__8f24ea7f__"